
import React from 'react';
import AccountSettings from '@/components/AccountSettings';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/components/Layout';
import PageHeader from '@/components/PageHeader';
import { useLanguage } from '@/contexts/LanguageContext';

const AccountSettingsPage = () => {
  const { t } = useLanguage();
  
  return (
    <ProtectedRoute>
      <Layout>
        <div className="flex flex-col h-full">
          <PageHeader title={t('settings.accountSettings')} />
          <div className="px-2 sm:px-4 py-4">
            <AccountSettings />
          </div>
        </div>
      </Layout>
    </ProtectedRoute>
  );
};

export default AccountSettingsPage;
